import { isAuthConfigured, loginRequest } from '@/authConfig';
import { getUserAccessToken, isTokenExpired } from '@/common/utils/auth';
import { PublicClientApplication } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import Loader from '../loader/Loader';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { instance } = useMsal();
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isAuthConfigured) {
      setIsLoading(false);
      return;
    }

    const checkToken = async () => {
      try {
        const token = await getUserAccessToken(
          instance as PublicClientApplication
        );
        setAccessToken(token);

        if (!token || isTokenExpired(token)) {
          instance
            .loginRedirect(loginRequest)
            .catch(error => console.log(error));
        }
      } catch (error) {
        console.log('Error getting access token:', error);
        instance.loginRedirect(loginRequest).catch(error => console.log(error));
      } finally {
        setIsLoading(false);
      }
    };

    checkToken();
  }, [instance]);

  if (isLoading) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
